import { ref } from 'vue'

// Global notification state
const notifications = ref([])
let notificationId = 0

export function useNotification() {
  const addNotification = (
    title,
    message,
    type = 'info',
    duration = 5000
  ) => {
    const id = ++notificationId
    const notification = {
      id,
      title,
      message,
      type,
      duration,
    }

    notifications.value.push(notification)

    if (duration > 0) {
      setTimeout(() => {
        removeNotification(id)
      }, duration)
    }

    return id
  }

  const removeNotification = (id) => {
    const index = notifications.value.findIndex((n) => n.id === id)
    if (index > -1) {
      notifications.value.splice(index, 1)
    }
  }

  const success = (title, message, duration) => {
    return addNotification(title, message, 'success', duration)
  }

  const error = (title, message, duration) => {
    return addNotification(title, message, 'error', duration)
  }

  const warning = (title, message, duration) => {
    return addNotification(title, message, 'warning', duration)
  }

  const info = (title, message, duration) => {
    return addNotification(title, message, 'info', duration)
  }

  return {
    notifications,
    addNotification,
    removeNotification,
    success,
    error,
    warning,
    info,
  }
}

export function withNotification(
  fn,
  { successTitle, successMessage, errorTitle, fallbackErrorMessage }
) {
  const { success, error } = useNotification()

  return async function (...args) {
    try {
      const result = await fn(...args)

      if (successTitle && successMessage) {
        success(successTitle, successMessage)
      }

      return result
    } catch (err) {
      const errorMessage = err?.errorMessage || err?.message || fallbackErrorMessage
      if (errorTitle) {
        error(errorTitle, errorMessage)
      }
      throw err
    }
  }
}
